import { User } from "../../../commons/auth";

export class ClientePolicy {
  view(user: User, context?: any){
    return true
  }
  register(user: User, context?: any){
    return true
  }
}